import React, { createContext, useState, useEffect, useContext } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Theme state
    const [isDark, setIsDark] = useState(() => {
        if (localStorage.getItem("theme") === "dark") return true;
        if (localStorage.getItem("theme") === "light") return false;
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    });

    // FPS state
    const [showFps, setShowFps] = useState(() => {
        return localStorage.getItem("setting_show_fps") === "true";
    });

    // Music Player state
    const [enableMusic, setEnableMusic] = useState(() => {
        return localStorage.getItem("setting_enable_music") !== "false";
    });

    // Low-end device mode state
    const [lowEndMode, setLowEndMode] = useState(() => {
        return localStorage.getItem("setting_low_end_mode") === "true";
    });

    // Sync dark class on document element
    useEffect(() => {
        const root = window.document.documentElement;
        if (isDark) {
            root.classList.add("dark");
            localStorage.setItem("theme", "dark");
        } else {
            root.classList.remove("dark");
            localStorage.setItem("theme", "light");
        }
    }, [isDark]);

    // Sync low-end class on document element
    useEffect(() => {
        const root = window.document.documentElement;
        if (lowEndMode) {
            root.classList.add("low-end");
            localStorage.setItem("setting_low_end_mode", "true");
        } else {
            root.classList.remove("low-end");
            localStorage.setItem("setting_low_end_mode", "false");
        }
    }, [lowEndMode]);

    // Save showFps setting
    useEffect(() => {
        localStorage.setItem("setting_show_fps", showFps ? "true" : "false");
    }, [showFps]);

    // Save enableMusic setting
    useEffect(() => {
        localStorage.setItem("setting_enable_music", enableMusic ? "true" : "false");
    }, [enableMusic]);

    const toggleTheme = () => setIsDark((prev) => !prev);

    return (
        <ThemeContext.Provider value={{ 
            isDark, 
            toggleTheme, 
            showFps, 
            setShowFps, 
            enableMusic, 
            setEnableMusic, 
            lowEndMode, 
            setLowEndMode 
        }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
